'use client';

import React, { useEffect } from 'react';

import { Property } from 'csstype';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';

const Wrapper = styled.div<{ all?: Property.All }>`
  all: ${({ all = 'inherit' }) => all};
  width: 100%;
`;

type IsInViewPortProps = React.PropsWithChildren<{
  onViewVisible: () => void;
  cssAll?: Property.All;
}>;
const IsInViewPort = ({
  children,
  onViewVisible,
  cssAll,
}: IsInViewPortProps) => {
  const { ref: campaignsRef, inView: isInView } = useInView({
    triggerOnce: true,
  });

  useEffect(() => {
    if (isInView) {
      onViewVisible?.();
    }
  }, [isInView]);

  return (
    <Wrapper all={cssAll} ref={campaignsRef}>
      {children}
    </Wrapper>
  );
};

export default IsInViewPort;
